/**
 * Import React Query Hooks
 */

import { useMutation } from '@tanstack/react-query';
import { importService } from '../services';

export function usePreviewImport() {
  return useMutation({
    mutationFn: ({ csvContent, delimiter, importType }) => 
      importService.previewParents(csvContent, delimiter, importType),
  });
}

export function useValidateImport() {
  return useMutation({
    mutationFn: ({ csvContent, mappings, importType, delimiter }) => 
      importService.validateParents(csvContent, mappings, importType, delimiter),
  });
}

export function useExecuteImport() {
  return useMutation({
    mutationFn: ({ csvContent, mappings, options }) => 
      importService.importParents(csvContent, mappings, options),
  });
}
